import Vue from "vue";
import axios from "axios";
import swal from "sweetalert";

const FEATURED_LIMIT = 4

export default {
  state: {
    activeResource: {
      published: null,
      sections: null,
      ref: null,
      quiz_selections: null,
      quiz_feedback: null,
      poll_selections: null,
      poll_popularity: null,
      quiz_popularity: null,
      related_resources: null,
      active_discussions: null,
      source_document: null,
      editable: null,
      id: null,
      title: null,
      introduction: null,
      image: null,
      tags: null,
      disable_attachments: null,
      existing_responses: null,
      is_favourite: null,
      active: null
    },
    latestDraft: null,
    localResourceMap: {},
    loading: false,
    featuredResources: [...Array(FEATURED_LIMIT).keys()]
  },
  mutations: {
    setActiveResource(state, resource) {
      state.activeResource = resource;
    },
    setLatestDraft(state, draft) {
      state.latestDraft = draft;
    },
    setFeedback(state, responses) {
      if (responses) {
        state.feedback = responses;
      }
    },
    setMatchingResponse(state, res) {
      let resource = { ...state.activeResource };
      resource.sections[res.section].pairs[res.question].match = res.answer;
      state.activeResource = resource;
    },
    setQuizResponse(state, res) {
      let resource = { ...state.activeResource };
      resource.sections[res.section].questions[res.question].selected =
        res.answer;
      state.activeResource = resource;
    },
    clearResourceState(state) {
      state.feedback = setValues(state.feedback, []);
      state.activeResource = setValues(state.activeResource, null);
    },
    setQuizSubmitted(state, val) {
      state.activeResource.quizSubmitted = val;
    },
    addLocalResources(state, resources) {
      resources.forEach((res) => Vue.set(state.localResourceMap, res.id, res));
    },
    addFeaturedResources(state, resources) {
      state.featuredResources = resources;
    },
  },
  getters: {
    sectionIds(state) {
      if (state.activeResource.sections) {
        return state.activeResource.sections.map(s => s.id);
      } else {
        return [];
      }
    },
    // Return a function so that the value isn't cached
    uniqueSectionId: (state, getters) => () => {
      let ids = getters.sectionIds;
      let newId;
      while (!newId || ids.includes(newId)) {
        newId = Math.floor(Math.random() * 1000000).toString().padStart(6, 0);
      };
      return newId;
    },
    localResourceMap(state) {
      return state.localResourceMap;
    },
    activeResourceId(state) {
      return state.activeResource.id;
    },
    loadingResources(state) {
      return state.loading;
    },
  },
  actions: {
    addMatchingResponse(response, complete) {
      commit("setMatchingResponse", response);
    },
    addQuizResponse(response, complete) {
      commit("setQuizResponse", response);
    },
    submitScoredResponses({ commit, dispatch }, responseData) {
      axios
        .post("/api/resource-library/" + responseData.ref + "/progress", {
          type: "quiz",
          responses: responseData.responses,
        })
        .then(() => {
          commit("setQuizSubmitted", true);
          dispatch("retrieveResource", responseData.ref);
        })
        .catch((err) => {
          swal("A submission error occured. Please try again.");
        });
    },
    retrieveResource({commit, state}, ref, lang="en") {
      return new Promise((resolve, reject) => {
        if (
          ref == state.activeResource.ref &&
          !state.activeResource.quizSubmitted
        ) {
          resolve();
          return;
        }
        axios.get("/api/resource-library/resource/" + ref, {
          headers: {
            "Content-Language": lang
          }
        }).then(response => {
          let data = {};
          for (var key in response.data) {
            data[key] = response.data[key];
          }
          commit("setLatestDraft", data.draft)
          delete data.draft;
          commit("setActiveResource", data);
          commit("setQuizSubmitted", false);
          resolve();
        }).catch(err => {
          reject(err);
        });
      });
    },
    async fetchFeaturedResources({ commit, state }) {
      try {
        let res = await axios.get(`/api/resource-library/resources/featured/${FEATURED_LIMIT}`);
        commit("addFeaturedResources", res.data);
      } catch (e) {}
    },
    async fetchResources({ commit, state }, resourceIds) {
      let missingIds = resourceIds.filter(
        (id) => !state.localResourceMap.hasOwnProperty(id)
      );
      if (missingIds.length) {
        state.loading = true;
        let params = { ids: missingIds.join(",") };
        try {
          let res = await axios.get("/api/resource-library/resources", {
            params,
          });
          commit("addLocalResources", res.data);
          state.loading = false;
        } catch (e) {}
      }
    },
  },
};

const setValues = (obj, val) => {
  for (let prop in obj) {
    obj[prop] = val;
  }
  return obj;
};
